import initCarousel from '../helpers/carousel';

export default class DynamicTestimonialsSimple {
  constructor(section) {
    const selectors = {
      testimonialsCarousel: '[data-testimonials-carousel-simple]',
      prevButton: '.splide__arrow--prev',
      nextButton: '.splide__arrow--next',
      paginationButtons: '.splide__pagination__button',
    };

    this.el = section.el;
    this.testimonialsCarousel = this.el.querySelector(
      selectors.testimonialsCarousel,
    );
    this.prevButton = this.el.querySelector(selectors.prevButton);
    this.nextButton = this.el.querySelector(selectors.nextButton);
    this.paginationButtons = this.el.querySelectorAll(
      selectors.paginationButtons,
    );

    this._initCarousels();
    this._bindEvents();
  }

  _initCarousels() {
    if (!this.testimonialsCarousel) {
      return;
    }

    /** Initialize content carousel */
    this.mainCarousel = initCarousel(
      this.testimonialsCarousel,
      {
        type: 'slide',
        perPage: 1,
        perMove: 1,
        gap: '1rem',
        pagination: true,
        arrows: false,
      },
      true,
    );
  }

  _bindEvents() {
    if (this.prevButton && this.nextButton && this.mainCarousel) {
      this.prevButton.addEventListener('click', () => {
        if (!this.prevButton.disabled) {
          this.mainCarousel.go('<');
        }
      });

      this.nextButton.addEventListener('click', () => {
        if (!this.nextButton.disabled) {
          this.mainCarousel.go('>');
        }
      });
    }

    this.paginationButtons.forEach((button, index) => {
      button.addEventListener('click', () => {
        this.mainCarousel.go(index);

        this.paginationButtons.forEach(paginationButton => {
          paginationButton.classList.remove('opacity-100');
          paginationButton.classList.add('opacity-50');
        });

        button.classList.remove('opacity-50');
        button.classList.add('opacity-100');
      });
    });
  }
}
